import Button from 'components/ui/Button'

interface IFooterProps {
  cancelText?: string
  onCancel?: () => void
  saveText?: string
  onSave?: () => void
}

export default function Footer({
  cancelText = 'Cancel',
  onCancel,
  saveText = 'Save',
  onSave
}: IFooterProps) {
  return (
    <div className="flex justify-end gap-2 bg-white py-7 px-6">
      <Button onClick={onCancel}>{cancelText}</Button>
      <Button cc-color="purple" onClick={onSave}>
        {saveText}
      </Button>
    </div>
  )
}
